/* eslint-disable */
import {
  GET_ROOT_DOCUMENTS_AND_DIRECTORIES,
  GET_DIRECTORY_DOCUMENTS,
  GET_DOCUMENT,
  GET_DOCUMENT_FUND,
  GET_DOCUMENTS_PART,
  GET_DOCUMENT_PART,
} from "../actionTypes";

const initialStateDocument: DocumentState = {};

export const DocumentReducer = (
  state: DocumentState = initialStateDocument,
  action: DocumentActions
) => {
  switch (action.type) {
    case GET_ROOT_DOCUMENTS_AND_DIRECTORIES:
      return {
        ...state,
        root_documents_directories_list: action.payload,
      };
    case GET_DIRECTORY_DOCUMENTS:
      return {
        ...state,
        directory_documents: action.payload,
      };
    case GET_DOCUMENT:
      return {
        ...state,
        document: action.payload,
      };
    case GET_DOCUMENT_FUND:
      return {
        ...state,
        fundDocument: action.payload,
      };
    case GET_DOCUMENTS_PART:
      return {
        ...state,
        partDocuments: action.payload,
      };
    case GET_DOCUMENT_PART: 
      return {
        ...state,
        partDocument: action.payload,
      }
    default:
      return {
        ...state,
      };
  }
};
